import { useEffect, useState } from 'react';
import {
  selectMemberConfig,
  UpdateOnboardingChecklistViewCount,
} from '../../../store/slices/dashboardSlice';
import { useAppDispatch, useAppSelector } from '../../../store/hooks';
import { useUpdateChecklistCompletedStepsByKey } from './useUpdateChecklistCompletedStepsByKey';
import { useCustomEventTracking } from '../../../common/useCustomEventTracking';

export function useTrackedChecklistUpdate(stepKey: string) {
  const dispatch = useAppDispatch();
  const updateChecklist = useUpdateChecklistCompletedStepsByKey();
  const { trackEngagement } = useCustomEventTracking();
  const storeMemberConfig = useAppSelector(selectMemberConfig);
  const [hasUpdated, setHasUpdated] = useState(false);

  useEffect(() => {
    if (!hasUpdated && storeMemberConfig?.showOnboardingChecklist) {
      updateChecklist(stepKey);
      trackEngagement('OnboardingChecklist', 'Click', stepKey);
      dispatch(UpdateOnboardingChecklistViewCount(0));
      setHasUpdated(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeMemberConfig, hasUpdated]);
}
